/*!
 * Launch countdown (launch-countdown.liquid)
 * Vanilla JS, no dependencies. Safe to load more than once per page.
 */
(function (root) {
  'use strict';

  var ISO_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/;

  // Namespace is reused across repeat script loads; only the pure helpers
  // are re-declared (idempotent), DOM wiring below guards on a flag.
  var LP = root.lpCountdown || {};

  LP.parseTarget = function parseTarget(str) {
    if (typeof str !== 'string') return null;
    var trimmed = str.trim();
    if (!ISO_RE.test(trimmed)) return null;
    var date = new Date(trimmed);
    if (isNaN(date.getTime())) return null;
    return date;
  };

  LP.remaining = function remaining(targetDate, now) {
    var diffMs = targetDate.getTime() - now.getTime();
    if (diffMs <= 0) {
      return { expired: true, days: 0, hours: 0, mins: 0, secs: 0 };
    }
    var totalSeconds = Math.floor(diffMs / 1000);
    return {
      expired: false,
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      mins: Math.floor((totalSeconds % 3600) / 60),
      secs: totalSeconds % 60
    };
  };

  LP.pad2 = function pad2(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : String(n);
  };

  root.lpCountdown = LP;

  // ---- DOM wiring (browser only) ----------------------------------------

  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      module.exports = LP;
    }
    return;
  }

  function initRoot(el) {
    if (!el || el.__lpInitialized) return;
    el.__lpInitialized = true;

    var targetStr = el.getAttribute('data-target');
    var afterMode = el.getAttribute('data-after-mode') || 'swap';
    var targetDate = LP.parseTarget(targetStr);

    var digitEls = {
      days: el.querySelector('[data-lp-unit="days"]'),
      hours: el.querySelector('[data-lp-unit="hours"]'),
      mins: el.querySelector('[data-lp-unit="mins"]'),
      secs: el.querySelector('[data-lp-unit="secs"]')
    };
    var gridEl = el.querySelector('[data-lp-countdown-grid]');
    var afterEl = el.querySelector('[data-lp-after-text]');
    var warningEl = el.querySelector('[data-lp-warning]');
    var timeoutId = null;

    function showWarning() {
      if (warningEl && root.Shopify && root.Shopify.designMode) {
        warningEl.hidden = false;
      }
    }

    function applyAfterState() {
      if (afterMode === 'hide') {
        el.hidden = true;
        return;
      }
      if (gridEl) gridEl.hidden = true;
      var labelEl = el.querySelector('.lp-countdown__label');
      if (labelEl) labelEl.hidden = true;
      if (afterEl) afterEl.hidden = false;
    }

    function render(rem) {
      if (digitEls.days) digitEls.days.textContent = LP.pad2(rem.days);
      if (digitEls.hours) digitEls.hours.textContent = LP.pad2(rem.hours);
      if (digitEls.mins) digitEls.mins.textContent = LP.pad2(rem.mins);
      if (digitEls.secs) digitEls.secs.textContent = LP.pad2(rem.secs);
    }

    function clearTimer() {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }

    function tick() {
      if (document.hidden) return; // resumed by onVisibilityChange
      var now = new Date();
      var rem = LP.remaining(targetDate, now);
      if (rem.expired) {
        render({ days: 0, hours: 0, mins: 0, secs: 0 });
        clearTimer();
        applyAfterState();
        return;
      }
      render(rem);
      var msToNextSecond = 1000 - (now.getTime() % 1000);
      timeoutId = setTimeout(tick, msToNextSecond);
    }

    function onVisibilityChange() {
      if (!document.hidden) {
        clearTimer();
        tick();
      }
    }

    if (!targetDate) {
      showWarning();
      el.__lpCleanup = function () {};
      return;
    }

    document.addEventListener('visibilitychange', onVisibilityChange);
    tick();

    el.__lpCleanup = function () {
      clearTimer();
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }

  function destroyRoot(el) {
    if (!el || !el.__lpInitialized) return;
    if (el.__lpCleanup) {
      el.__lpCleanup();
      el.__lpCleanup = null;
    }
    el.__lpInitialized = false;
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-lp-countdown]');
    for (var i = 0; i < list.length; i++) {
      initRoot(list[i]);
    }
  }

  // Guard against the script tag being present more than once on a page:
  // functions above are harmless to redefine, but DOM listeners and the
  // first init pass must only run once.
  if (!root.__lpCountdownBooted) {
    root.__lpCountdownBooted = true;

    initAll(document);

    document.addEventListener('shopify:section:load', function (evt) {
      var found = evt.target && evt.target.querySelector
        ? evt.target.querySelector('[data-lp-countdown]')
        : null;
      if (found) initRoot(found);
    });

    document.addEventListener('shopify:section:unload', function (evt) {
      var found = evt.target && evt.target.querySelector
        ? evt.target.querySelector('[data-lp-countdown]')
        : null;
      if (found) destroyRoot(found);
    });
  }
})(typeof window !== 'undefined' ? window : this);
